import { Injectable } from '@angular/core';
import { AuthGuardService } from '@shared/services/auth-guard.service';

@Injectable()
export class StockCountHistoryPermission {
  constructor(protected authGuardService: AuthGuardService) {}

  public get hasViewStockCountHistory(): boolean {
    return this.authGuardService.checkPermission(['pm_stkcnt_his_v']);
  }
}
